import { User } from "lucide-react";

export default function ProfileTabs({ activeTab, setActiveTab }: any) {
  const tabs = [
    { id: "profile", label: "Personal Information", icon: <User size={18} /> },
  ];

  return (
    <div className="border-b border-gray-200 p-4 flex gap-2">
      {tabs.map((t) => (
        <button
          key={t.id}
          onClick={() => setActiveTab(t.id)}
          className={`px-4 py-2 rounded-lg flex items-center gap-2 font-medium
            ${
              activeTab === t.id
                ? "bg-blue-50 text-blue-600 border border-blue-200"
                : "text-gray-600 hover:bg-gray-100"
            }`}
        >
          {t.icon}
          {t.label}
        </button>
      ))}
    </div>
  );
}
